import { api_trade_stats } from './utils';

export async function fetchUserStats(scwAddress: string) {
	if (!scwAddress) return;
	const response = await api_trade_stats('get', `clan-wars/${scwAddress}/stats`);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}

	throw new Error(`Failed to fetch user stats for ${scwAddress}`);
}

export async function fetchClanWarsSummary() {
	const response = await api_trade_stats('get', `clan-wars/summary`);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}

	throw new Error(`Failed to fetch clan wars summary`);
}
